import { render, staticRenderFns } from "./ToDoTasksTableTabs.vue?vue&type=template&id=5b838003&scoped=true&lang=pug"
import script from "./ToDoTasksTableTabs.vue?vue&type=script&lang=ts"
export * from "./ToDoTasksTableTabs.vue?vue&type=script&lang=ts"
import style0 from "./ToDoTasksTableTabs.vue?vue&type=style&index=0&id=5b838003&prod&lang=sass&scoped=true"
import style1 from "./ToDoTasksTableTabs.vue?vue&type=style&index=1&id=5b838003&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b838003",
  null
  
)

/* custom blocks */
import block0 from "./ToDoTasksTableTabs.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FTasks%2FToDoTasksTable%2FToDoTasksTableTabs.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports